export default {
    controller: 'dashboardController',
    template: require('../views/dashboard.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/components/dashboard.component.js